import { Action, createAction, handleActions } from "redux-actions";
import {
  GetPolizasRequest,
  GetPolizasResponse,
  PolizaResponse,
} from "~api/types";
import { Dispatch, FiltroValue, GetState, Services, TakeValue } from "../types";

/**
 * `polizas` queda en null al reinicializar la bandeja: es el estado previo a la
 * primera respuesta, distinto de "no hay resultados".
 */
interface PolizasState {
  polizas: PolizaResponse[] | null;
  isLoading: boolean;
  failed: boolean;
  totalRegistros: number;
  page: number;
  take: TakeValue;
  reloadPolizas: boolean;
  polizaAnulada: boolean;
}

const setInitialState = createAction("SET_POLIZAS_INITIAL_STATE");

const getPolizasInited = createAction("OBTENER_POLIZAS_INITED");

const closeSuccessAnularPopUp = createAction("CLOSE_SUCCESS_ANULAR_POPUP");

const getPolizasCompleted = createAction(
  "OBTENER_POLIZAS_COMPLETED",
  (response: GetPolizasResponse | null | undefined) => {
    let polizas: PolizaResponse[] = [];
    let totalRegistros = 0;

    if (response != null) {
      polizas = response.polizas;
      totalRegistros = response.totalRegistros;
    }

    return { polizas, totalRegistros };
  }
);
const getPolizasFailed = createAction(
  "OBTENER_POLIZAS_FAILED",
  (error: unknown) => ({
    error,
  })
);

const patchAnularPolizaInited = createAction("ANULAR_POLIZA_INITED");

const patchAnularPolizaCompleted = createAction("ANULAR_POLIZA_COMPLETED");
const patchAnularPolizaFailed = createAction(
  "ANULAR_POLIZA_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getPolizas = ({
  skip,
  take,
  fechaDesde,
  fechaHasta,
  searchCriteria,
  negocio,
  estado,
  soloParaRenovar,
  compania,
}: GetPolizasRequest) => {
  return async (dispatch: Dispatch, getState: GetState, services: Services) => {
    try {
      dispatch(getPolizasInited());

      const data = {
        skip,
        take,
        fechaDesde,
        fechaHasta,
        searchCriteria,
        estado,
        negocio,
        soloParaRenovar,
        compania,
      };
      const response = await services.api.polizas().getPolizas(data);

      dispatch(getPolizasCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getPolizasFailed(error));
    }
  };
};

const patchAnularPoliza = (
  polizaId: string,
  motivo: FiltroValue,
  fechaAnulacion: string
) => {
  return async (dispatch: Dispatch, getState: GetState, services: Services) => {
    try {
      dispatch(patchAnularPolizaInited());

      const data = {
        motivo,
        fechaAnulacion,
      };
      await services.api.polizas().patchAnularPoliza(polizaId, data);

      dispatch(patchAnularPolizaCompleted());
    } catch (error) {
      console.error(error);
      dispatch(patchAnularPolizaFailed(error));
    }
  };
};

const polizasInitialState: PolizasState = {
  polizas: null,
  isLoading: false,
  failed: false,
  totalRegistros: 0,
  page: 0,
  take: 10,
  reloadPolizas: false,
  polizaAnulada: false,
};

const polizasReducer = handleActions<PolizasState, any>(
  {
    [setInitialState.toString()]: (): PolizasState => {
      return {
        ...polizasInitialState,
        polizas: null,
      };
    },
    [getPolizasInited.toString()]: (state: PolizasState): PolizasState => {
      return {
        ...state,
        totalRegistros: 0,
        isLoading: true,
      };
    },
    [getPolizasCompleted.toString()]: (
      state: PolizasState,
      action: Action<{ polizas: PolizaResponse[]; totalRegistros: number }>
    ): PolizasState => {
      return {
        ...state,
        polizas: action.payload.polizas,
        totalRegistros: action.payload.totalRegistros,
        isLoading: false,
        failed: false,
        reloadPolizas: false,
      };
    },
    [getPolizasFailed.toString()]: (state: PolizasState): PolizasState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
        reloadPolizas: false,
      };
    },
    [patchAnularPolizaInited.toString()]: (
      state: PolizasState
    ): PolizasState => {
      return {
        ...state,
        polizaAnulada: false,
        isLoading: true,
      };
    },
    [patchAnularPolizaCompleted.toString()]: (
      state: PolizasState
    ): PolizasState => {
      return {
        ...state,
        polizaAnulada: true,
        isLoading: false,
      };
    },
    [patchAnularPolizaFailed.toString()]: (
      state: PolizasState
    ): PolizasState => {
      return {
        ...state,
        polizaAnulada: false,
        isLoading: false,
      };
    },
    [closeSuccessAnularPopUp.toString()]: (
      state: PolizasState
    ): PolizasState => {
      return {
        ...state,
        polizaAnulada: false,
      };
    },
  },
  polizasInitialState
);

export { polizasReducer };
export {
  getPolizas,
  patchAnularPoliza,
  setInitialState,
  closeSuccessAnularPopUp,
};
